import styled from '@emotion/styled';

export const PopperContainer = styled.div`
	width: 100%;
	box-shadow: var(--container-box-shadow);
	background: var(--modal-bg-3);
	padding: var(--padding-1);

	span.version {
		text-align: center;
		color: gray;
		display: flex;
		justify-content: center;
		margin-top: 0.5rem;
	}
`;
